<template>
  <modal :name="modalName"
         :draggable="true"
         width="90%"
         height="auto"
         :scrollable="true"
  >
    <div class="m-4 p-4 border border-gray-500">
      <deadline-form :actionUrl="'/deadlines/'+deadline.id+'.json'" method="put" :initial-deadline="deadline" v-on:updated="updated"/>
    </div>
  </modal>
</template>

<script>
export default {
  props: ['deadline'],
  data() {
    return {
      modalName: 'deadline-form-modal-'+this.deadline.id,
    }
  },
  methods: {
    updated: function (event) {
      this.$modal.hide(this.modalName);
      this.$emit('updated');
    },
  }
}
</script>